import React from "react";
import styled from "styled-components";
import { tokens } from "../../../../../public/tokens";

const StyledBanner = styled.div({
    width: "100%",
    padding: tokens.globals["spacing-3-5"],

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: tokens.globals["spacing-2-5"],

    background: tokens.colors.states.success["100"],
    border: `${tokens.globals["spacing-px"]} solid ${tokens.colors.states.success["500"]}`,
    borderRadius: tokens.globals["border-radius"],
    boxShadow: tokens.effects.effects.shadow.default,

    boxSizing: "border-box",
});

const StyledMessage = styled.span({
    display: "inline-flex",
    alignItems: "center",
    gap: tokens.globals["spacing-2"],

    color: tokens.colors.text.primary,

    fontFamily: tokens.typography.fontFamilies["albert-sans"],
    fontSize: tokens.typography.fontSize["lg-14px"],
    fontWeight: tokens.typography.fontWeights.bold,
    lineHeight: 1.1,

    i: {
        color: tokens.colors.states.success["500"],
        fontSize: tokens.typography.fontSize["lg-14px"],
    },
});

const StyledDismiss = styled.button({
    width: tokens.globals["spacing-5"],
    height: tokens.globals["spacing-5"],

    padding: 0,
    border: 0,
    flexShrink: 0,

    background: "transparent",

    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",

    color: tokens.colors.text.primary,

    cursor: "pointer",

    "&:hover": {
        opacity: 0.8,
    },

    "&:focus-visible": {
        outline: `${tokens.globals["spacing-px"]} solid ${tokens.colors.brand.blue["500"]}`,
        outlineOffset: tokens.globals["spacing-0-5"],
        borderRadius: tokens.globals["border-radius"],
    },
});

function GradebookSuccessBanner({ message, onDismiss }) {
    return (
        <StyledBanner role="status">
            <StyledMessage>
                <i className="fas fa-check-circle" aria-hidden="true" />

                {message}
            </StyledMessage>

            <StyledDismiss type="button" onClick={onDismiss} aria-label="Dismiss">
                <i className="fal fa-times" aria-hidden="true" />
            </StyledDismiss>
        </StyledBanner>
    );
}

GradebookSuccessBanner.displayName = "GradebookSuccessBanner";

export default GradebookSuccessBanner;
